<template>
  <div class="route-search">
    <TitleFrame
      text="最終経路確認"
      :show-return="true"
      @click-close="onClickClose"
    >
      <template slot="contents">
        <div class="text-content upper-area" v-if="currentSearch">
          <p class="resultText">{{ currentSearch.departure }}</p>
          <!-- ルート検索の場合 -->
          <p class="triangle">▼</p>
          <div v-if="currentSearch.departure !== currentSearch.destination">
            <p v-if="currentDropDestionaton" class="resultDrop">
              <span v-if="currentDropDestionaton">{{
                currentDropDestionaton.name
              }}</span
              ><span class="grey" v-else>経由地なし</span>
            </p>
            <p v-if="currentDropDestionaton" class="triangle">▼</p>
            <p class="resultText">{{ currentSearch.destination }}</p>
          </div>
          <!-- エリア検索の場合 -->
          <div v-if="currentSearch.departure === currentSearch.destination">
            <p class="resultText">
              <template v-if="currentDropDestionaton">{{
                currentDropDestionaton.name
              }}</template>
            </p>
          </div>
          <div class="times" v-if="currentLastRoute">
            <span> {{ depTime }} - {{ desTime }} </span>
            <span>
              <img src="@/assets/car.svg" alt="" class="icon" />
              {{ displayTime }}
            </span>
            <span>
              <img src="@/assets/telescope.svg" alt="" class="icon" />
              {{
                formatDateFromSeconds(
                  currentDropDestionaton
                    ? currentDropDestionaton.stayTime
                      ? currentDropDestionaton.stayTime
                      : 0
                    : 0,
                )
              }}
            </span>
          </div>
        </div>
        <div
          class="map-area"
          :class="{
            mini:
              (!!currentSearch
                ? currentSearch.departure === currentSearch.destination
                : false) || !currentDropDestionaton,
          }"
        >
          <GoogleMapOnlyResult
            :key="$route.query.timestamp"
            v-if="currentSearchState === 'result'"
            :current="current"
          />
        </div>
        <div class="button">
          <ButtonLink
            text="音声案内マップアプリ起動"
            @click-text="onClickGoGoogle"
          />
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import GoogleMapOnlyResult from "@/components/Organisms/GoogleMapOnlyResult";
import ButtonLink from "@/components/Atoms/ButtonLink";
import Firebase from "./../../firebase";

export default {
  name: "route-result",
  components: {
    TitleFrame,
    GoogleMapOnlyResult,
    ButtonLink,
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "selectedSpotData",
      "search",
      "DepLatLng",
      "DesLatLng",
      "dropDestionaton",
      "lastRoute",
      "searchState",
    ]),
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
    currentSearchState() {
      if (this.current === "RouteSearch") {
        return this.searchState.dropspot;
      } else if (this.current === "MyPage") {
        return this.searchState.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.searchState.jyutai;
      }
    },
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "MyPage") {
        return this.search.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDropDestionaton() {
      if (this.current === "RouteSearch") {
        return this.dropDestionaton.dropspot;
      } else if (this.current === "MyPage") {
        return this.dropDestionaton.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.dropDestionaton.jyutai;
      }
    },
    currentLastRoute() {
      if (this.current === "RouteSearch") {
        return this.lastRoute.dropspot;
      } else if (this.current === "MyPage") {
        return this.lastRoute.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.lastRoute.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    depTime() {
      return this.formatDate(this.currentSearch.departureTime);
    },
    desTime() {
      if (!this.currentLastRoute) return "";
      const now = new Date(this.currentSearch.departureTime);
      now.setSeconds(now.getSeconds() + this.currentLastRoute.alltimeDuration);
      return this.formatDate(now);
    },
    displayTime() {
      let sec = this.currentLastRoute.duration;

      const min = parseInt(sec / 60);
      if (min < 60) return `${min}分`;

      const hour = parseInt(min / 60);
      const remainMin = parseInt(min % 60);

      return `${hour}時間 ${remainMin}分`;
    },
  },
  methods: {
    ...mapMutations(["setSearch", "loadingEndMini", "setSearchState"]),
    formatDate(date) {
      const hour = this.zeroPaddingAndStr(date.getHours());
      const minute = this.zeroPaddingAndStr(date.getMinutes());
      return `${hour}:${minute}`;
    },
    onClickClose() {
      if (this.current === "MyPage") {
        this.setSearchState("view");
      } else {
        if (this.currentSearch.timeIndex == 0) {
          this.setSearchState("search");
        }
        else {
          this.setSearchState("select");
        }
      }
    },
    zeroPaddingAndStr(num) {
      if (num < 10) {
        return "0" + String(num);
      }
      return String(num);
    },
    formatDateFromSeconds(value) {
      // 秒からX時間Y分に変換
      const hour = Math.floor(value / 3600);
      const minute = Math.round((value % 3600) / 60);
      return `${hour}時間${minute}分`;
    },
    onClickGoGoogle() {
      let url = "";
      if (
        this.currentDropDestionaton &&
        this.currentSearch.departure !== this.currentSearch.destination
      ) {
        url =
          "https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=" +
          this.currentSearch.departure +
          "&origin_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[0].place_id +
          "&waypoints=" +
          this.currentDropDestionaton.name +
          "&waypoints_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[1].place_id +
          "&destination=" +
          this.currentSearch.destination +
          "&destination_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[2].place_id;

        window.open(url, "_blank");
      } else if (
        this.currentSearch.departure === this.currentSearch.destination
      ) {
        url =
          "https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=" +
          this.currentSearch.departure +
          "&origin_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[0].place_id +
          "&destination=" +
          this.currentDropDestionaton.name +
          "&destination_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[1].place_id;

        window.open(url, "_blank");
      } else {
        const url =
          "https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=" +
          this.currentSearch.departure +
          "&origin_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[0].place_id +
          "&destination=" +
          this.currentSearch.destination +
          "&destination_place_id=" +
          this.currentLastRoute.route.geocoded_waypoints[1].place_id;

        window.open(url, "_blank");
      }
      const actionParams = {
        url: url,
        start_name: this.currentSearch.departure,
        start_lon: this.currentDepLatLng.lng(),
        start_lat: this.currentDepLatLng.lat(),
        start_time: this.depTime,
        goal_name: this.currentSearch.destination,
        goal_lat: this.currentDesLatLng.lng(),
        goal_lon: this.currentDesLatLng.lat(),
        goal_time: this.desTime,
        business_hour: this.selectedSpot
          ? this.selectedSpot.business_hours
            ? this.selectedSpot.business_hours
            : null
          : null,
      };

      Firebase.putLog({
        ActionType: "RunMapApp",
        ActionParams: actionParams,
      });
    },
  },
  async mounted() {
    // ログ用の処理ここから
    const actionParams = {
      start_name: this.currentSearch.departure,
      start_lon: this.currentDepLatLng.lng(),
      start_lat: this.currentDepLatLng.lat(),
      start_time: this.depTime,
      goal_name: this.currentSearch.destination,
      goal_lat: this.currentDesLatLng.lng(),
      goal_lon: this.currentDesLatLng.lat(),
      goal_time: this.desTime,
      business_hour: this.selectedSpot
        ? this.selectedSpot.business_hours
          ? this.selectedSpot.business_hours
          : null
        : null,
    };

    Firebase.putLog({
      ActionType: "SeeFinalRoute",
      ActionParams: actionParams,
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.route-search {
  height: 100%;
}
.map-area {
  height: calc(100% - 9.2rem);
  position: relative;
  &.mini {
    height: calc(100% - 6.8rem);
  }
}
.text-content {
  padding: 0 8px;
}

.button {
  position: fixed;
  bottom: 4rem;
  margin: 0 10vw;
  width: 80vw;
}
.upper-area {
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.resultText {
  background: #f6f6f6;
  border-radius: 24px;
  font-size: 0.8rem;
  padding: 0.1rem 1rem;
  margin: 0.1rem 0;
}

.triangle {
  text-align: center;
  color: #525252;
  font-size: 0.5rem;
  margin: 0;
}

.resultDrop {
  background: #f6f6f6;
  border-radius: 24px;
  font-size: 0.8rem;
  padding: 0.1rem 1rem;
  margin: 0.1rem 2rem;
  .grey {
    color: #bebebe;
    font-size: 0.7rem;
  }
}

.times {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  .icon {
    height: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/RouteResult.vue